var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.672 9.486 9.082 2.9a.322.322 0 0 0-.21-.078H7.093a.16.16 0 0 0-.105.281l7.035 6.107H2.268a.161.161 0 0 0-.16.16v1.206c0 .089.072.161.16.161h11.754l-7.035 6.107a.16.16 0 0 0 .105.281H8.93a.155.155 0 0 0 .104-.04l7.638-6.625a.643.643 0 0 0 0-.973z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFull);
export default __webpack_public_path__ + "static/media/arrow-right-full.aa65ccfc332c31fe4b87a90308b06fbf.svg";
export { ForwardRef as ReactComponent };